import {MutationTree} from "vuex";
import * as moment from "moment";
import Redemption from "../ts/Redemption";
import User from "../../UserManager/ts/User";

export const mutations: MutationTree<any> = {

    setLoading(state: any, payload: boolean) {
        state.loading = payload;
    },

    setAvailable(state: any, payload: boolean) {
        state.available = payload;
    },

    setApproving(state: any, payload: boolean) {
        state.approving = payload;
    },

    setRejecting(state: any, payload: boolean) {
        state.rejecting = payload;
    },

    clearCache(state: any) {
        state.expires = null;
    },

    setData(state: any, payload: Array<Redemption>) {
        state.redemptions = payload;
        state.expires = moment().add(15, 'minutes');
    },

    setApproved(state: any, payload: {ids: Array<number>, user: User, approved: boolean, history: boolean}) {

        const ids = payload.ids;
        const user = payload.user;

        let targetRedemptions = null;

        if (payload.history) {
            targetRedemptions = state.history.data.filter((redemption: Redemption) => ids.includes(redemption.id));
        } else {
            targetRedemptions = state.redemptions.filter((redemption: Redemption) => ids.includes(redemption.id));
        }

        if (targetRedemptions.length > 0) {
            targetRedemptions.forEach ((redemption: Redemption) => {
               redemption.approved = payload.approved;
               redemption.approved_by = user;
            });
        }
    },

    setHistory(state: any, payload: any) {
        state.history = payload;
    },

    setHistoryLoading(state: any, payload: boolean) {
        state.historyLoading = payload;
    },

    setHistoryTableOptions(state: any, payload: any) {
        state.historyTableOptions = Object.assign({},payload);
    },

    setHistoryTableFooterProps(state: any, payload: any) {
        state.historyTableFooterProps = Object.assign({},payload);
    }
};
